module.exports = __webpack_public_path__ + "static/media/B_E03.b926da33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_E03.png
// module id = 88
// module chunks = 0